import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CeLevelMenu, CeLevelMenuComponent, CeSkeletonLoaderImports } from '@kempower-nx-workspace/shared/kp-design-system';

@Component({
    selector: 'ce-core-side-nav-menu',
    imports: [CommonModule, CeLevelMenuComponent, CeSkeletonLoaderImports],
    templateUrl: './side-nav-menu.component.html'
})
export class CoreSideNavMenuComponent {
    navigationList = input<CeLevelMenu[]>([]);

    skeletonCount = [].map((_, i) => i);

    isLoading = computed(() => {
        return this.navigationList().length === 0;
    });

    constructor() {
        this.skeletonCount = Array(5)
            .fill(0)
            .map((x, i) => i);
    }
}
